import { Component, inject, signal } from '@angular/core';
import { RouterLink } from '@angular/router';
import { LanguageService, SupportedLocale } from '../../../services/language.service';

@Component({
  selector: 'app-organizer-navbar',
  imports: [RouterLink],
  templateUrl: './organizer-navbar.html',
  styleUrl: './organizer-navbar.css',
})
export class OrganizerNavbar {
  private langService = inject(LanguageService);

  currentLocale = this.langService.getCurrentLocale();
  isMenuOpen = signal(false);

  toggleMenu(): void {
    this.isMenuOpen.update((open) => !open);
  }

  closeMenu(): void {
    this.isMenuOpen.set(false);
  }

  switchLanguage(locale: SupportedLocale): void {
    this.langService.switchLanguage(locale);
  }
}
